import React from 'react';
import { EmailMailbox } from '../types';

interface EmailMailboxNavProps {
  nested?: boolean;
  mailboxes: EmailMailbox[];
  selectedMailbox: string;
  loading: boolean;
  error: string | null;
  onSelectMailbox: (path: string) => void;
}

const EmailMailboxNav: React.FC<EmailMailboxNavProps> = ({
  nested = false,
  mailboxes,
  selectedMailbox,
  loading,
  error,
  onSelectMailbox
}) => {
  const navClass = nested ? 'email-mailbox-nav email-mailbox-nav--nested' : 'email-mailbox-nav';

  if (loading && mailboxes.length === 0) {
    return <div className={`email-mailbox-nav-state${nested ? ' email-mailbox-nav-state--nested' : ''}`}>Loading folders…</div>;
  }

  if (error && mailboxes.length === 0) {
    return <div className={`email-mailbox-nav-state email-mailbox-nav-error${nested ? ' email-mailbox-nav-state--nested' : ''}`}>{error}</div>;
  }

  if (mailboxes.length === 0) {
    return <div className={`email-mailbox-nav-state${nested ? ' email-mailbox-nav-state--nested' : ''}`}>No folders found.</div>;
  }

  return (
    <nav className={navClass} aria-label="Mail folders">
      <ul className="email-mailbox-list">
        {mailboxes.map(box => (
          <li key={box.path}>
            <button
              type="button"
              className={`email-mailbox-item${selectedMailbox === box.path ? ' active' : ''}`}
              onClick={() => onSelectMailbox(box.path)}
              title={box.path}
            >
              {box.name}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default EmailMailboxNav;
